import { getAvailableAppearances } from '@/model/productType/getAvailableAppearances';
import { StoreState } from '@/redux/types';
import { getCurrentAppearance } from './getCurrentAppearance';
import { getProductType } from './getProductType';

export const getIsCurrentProductTypeAndAppearanceOutOfStock = (state: StoreState) => {
  const productType = getProductType(state);
  const availableAppearances = getAvailableAppearances(productType);
  return (
    availableAppearances.length === 0 || !availableAppearances.includes(getCurrentAppearance(state))
  );
};
